import React, { forwardRef, InputHTMLAttributes } from 'react';
import classNames from 'classnames';

import { LoadingSkeleton } from 'shared';

import classes from './Input.module.scss';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  labelText?: string;
  isLoading?: boolean;
  containerClassName?: string;
  className?: string;
  error?: string;
  testId?: string;
  endIcon?: React.ReactElement;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      labelText,
      name,
      isLoading = false,
      className,
      containerClassName,
      endIcon,
      error,
      testId = '',
      ...rest
    }: InputProps,
    ref,
  ) => {
    const testID = testId ? `${testId}-` : '';

    if (isLoading) return <LoadingSkeleton className={classNames(classes.loader)} />;

    return (
      <div className={classNames(classes.inputContainer, containerClassName)} data-testid={`${testID}input-container`}>
        <input
          {...rest}
          ref={ref}
          id={labelText}
          name={name}
          className={classNames(className, { [classes.inputError]: error })}
          data-testid={`${testID}input`}
        />
        {labelText && (
          <label className={classes.label} htmlFor={labelText}>
            {labelText}
          </label>
        )}
        {error && <label className={classes.error}>{error}</label>}
        {endIcon && (
          <div aria-disabled={rest.disabled} className={classes.iconContainer}>
            {endIcon}
          </div>
        )}
      </div>
    );
  },
);
